import { z } from 'zod';

export const footerSchema = z.object({
  copyrightLine: z.string().min(1),
  links: z
    .array(
      z.object({
        label: z.string().min(1),
        href: z.string().min(1),
      }),
    )
    .min(1),
});

export type Footer = z.infer<typeof footerSchema>;
